import { render } from "./iban-form.vue?vue&type=template&id=74155988&lang=true"
import script from "./iban-form.vue?vue&type=script&lang=js"
export * from "./iban-form.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__